<script setup>
import { ref, reactive, computed } from "vue";
import popupTitle from "@/components/popupTitle.vue";
import { Toast } from "vant";
import { commonStore } from "@/store/common";
import { swapStore } from "@/store/swap";
import { MaxUint256 } from "@ethersproject/constants";

const common_store = commonStore();
const swap_store = swapStore();
const empowerType = computed(() => common_store.empowerType);
const tokenId = computed(() => common_store.tokenId);
const text = computed(() => {
  if (empowerType.value == 2) {
    return "EmpowerAlert.btn2";
  } else if (empowerType.value == 3) {
    return "EmpowerAlert.btn3";
  } else {
    return "EmpowerAlert.btn4";
  }
});
let check = ref(false);
//首页token授权
const empower1 = async () => {
  console.log("empower", 1);
  if (!swap_store.tokenEmpower) {
    await swap_store.getTokenMethods();
  }

  try {
    const res = await swap_store.tokenMethods
      .approve(swap_store.nftSpender, MaxUint256)
      .send({ from: common_store.address });
    common_store.showEmpower(false);
    swap_store.setEmpower();
    check.value = false;
  } catch (error) {
    common_store.showEmpower(false);
    check.value = false;
    Toast(error);
  }
};

//个人出售授权
const empower2 = async () => {
  console.log("empower", 2);
  try {
    const res = await common_store.allMethods
      .approve(common_store.market_address, tokenId.value)
      .send({ from: common_store.address });
    common_store.showEmpower(false);
    check.value = false;
  } catch (error) {
    common_store.showEmpower(false);
    check.value = false;
    Toast(error);
  }
};

//兑换usdt授权
const empower3 = async () => {
  console.log("empower", 3);
  try {
    const res = await swap_store.usdtMethods
      .approve(swap_store.marketSpender, MaxUint256)
      .send({ from: common_store.address });
    swap_store.setUsdtEmpower();
    common_store.showEmpower(false);
    check.value = false;
  } catch (error) {
    common_store.showEmpower(false);
    check.value = false;

    Toast(error);
  }
};
//兑换token授权
const empower4 = async () => {
  console.log("empower", 4);
  try {
    const res = await swap_store.tokenMethods
      .approve(swap_store.marketSpender, MaxUint256)
      .send({ from: common_store.address });
    swap_store.setMarketEmpower();
    common_store.showEmpower(false);
    check.value = false;
  } catch (error) {
    common_store.showEmpower(false);
    check.value = false;
    Toast(error);
  }
};

//市场购买
const empower5 = async () => {
  console.log("empower", 5);
  try {
    const res = await swap_store.tokenMethods
      .approve(swap_store.marketSpender, MaxUint256)
      .send({ from: common_store.address });
    swap_store.setMarketEmpower();
    common_store.showEmpower(false);
    check.value = false;
  } catch (error) {
    common_store.showEmpower(false);
    check.value = false;
    Toast(error);
  }
};
const submit = () => {
  check.value = true;
  switch (empowerType.value) {
    case 1:
      empower1();
      break;
    case 2:
      empower2();
      break;
    case 3:
      empower3();
      break;
    case 4:
      empower4();
      break;
    case 5:
      empower5();
      break;
  }
};
const close = () => {
  check.value = false;
  common_store.showEmpower(false);
};
</script>
<template>
  <div class="bind allFlex column">
    <popup-title
      :title="$t('EmpowerAlert.title')"
      @closeFn="close"
      :loading="check"
    ></popup-title>
    <div class="padding">
      <div class="text padding Wcolor center font-Six" v-if="empowerType == 2">
        {{ $t("EmpowerAlert.one", { tokenId }) }}
      </div>

      <div v-if="empowerType == 3" class="text padding Wcolor center font-Six">
        {{ $t("EmpowerAlert.two") }}
      </div>
      <div v-if="empowerType == 1" class="text padding Wcolor center font-Six">
        {{ $t("EmpowerAlert.three") }}
      </div>
      <div
        v-if="empowerType == 4 || empowerType == 5"
        class="text padding Wcolor center font-Six"
      >
        {{ $t("EmpowerAlert.four") }}
      </div>
    </div>

    <div class="btn">
      <van-button class="btn" type="primary" block @click="submit">{{
        check ? $t("EmpowerAlert.btn1") : $t(text)
      }}</van-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bind {
  height: 230px;
  width: 315px;
  padding: 4px;
  background: url("../assets/commonImg/alert-bg1.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 40px;
}
.text {
  line-height: 30px;
  padding: 15px 0;
}
.btn {
  padding: 0 30px;
}
</style>
